<template>
    <div v-loading="dataLoading">
        <table v-if="data" class="info-table" width="100%">
            <tr>
                <th>合同编号</th>
                <td>{{data.contractSn}}</td>
            </tr>
            <tr>
                <th>合同到期时间</th>
                <td>{{data.contractExpireTime}}</td>
            </tr>
            <tr>
                <th>收款联系人姓名</th>
                <td>{{data.userName}}</td>
            </tr>
            <tr>
                <th>收款联系人手机</th>
                <td>{{data.userTelephone}}</td>
            </tr>
            <tr>
                <th>收款联系人邮箱</th>
                <td>{{data.userEmail}}</td>
            </tr>
            <tr>
                <th>通讯地址</th>
                <td>{{data.address}}</td>
            </tr>
            <tr>
                <th>银行</th>
                <td>{{data.bankName}}</td>
            </tr>
            <tr>
                <th>开户网点</th>
                <td>{{data.bankAddress}}</td>
            </tr>
            <tr>
                <th>银行卡号</th>
                <td>{{data.bankCardId}}</td>
            </tr>
            <tr>
                <th>账户性质</th>
                <td>{{accountType.get(data.accountType)}}</td>
            </tr>
            <tr>
                <th>账户名</th>
                <td>{{data.bankAccount}}</td>
            </tr>
			<tr>
			    <th>法人代表姓名</th>
			    <td>{{data.corporationName}}</td>
			</tr>
            <template v-if="data.accountType == 2">
                <tr>
                    <th>证件类型</th>
                    <td>{{data.accountIdName}}</td>
                </tr>
                <tr>
                    <th>证件号码</th>
                    <td>{{data.userID}}</td>
                </tr>
                <tr>
                    <th>证件</th>
                    <td>
                        <template v-for="(item,index) in data.accountPic">
                            <el-image :src="item" :key="index" fit="cover" :preview-src-list="data.accountPic"></el-image>
                        </template>
                    </td>
                </tr>
            </template>
            <template v-if="data.accountType == 1">
                <tr>
                    <th>营业执照编号</th>
                    <td>{{data.userID}}</td>
                </tr> 
                <tr>
                    <th>营业执照</th>
                    <td>
                        <template v-for="(item,index) in data.accountPic">
                            <el-image :src="item" :key="index" fit="cover" :preview-src-list="data.accountPic"></el-image>
                        </template>
                    </td>
                </tr>   
                <tr>
                    <th>开户许可证/基本存款账户信息</th>
                    <td>
                        <template v-for="(item,index) in data.otherPic">
                            <el-image :src="item" :key="index" fit="cover" :preview-src-list="data.otherPic"></el-image>
                        </template>
                    </td>
                </tr>
				<tr>
				    <th>企业类型</th>
				    <td>{{data.businessType == 0 ? '有限责任公司（自然人投资或控股）' : '股份有限公司'}}</td>
				</tr>
				<tr>
				    <th>注册地址</th>
				    <td>{{data.registeredAddress}}</td>
				</tr>
				<tr>
				    <th>注册资本</th>
				    <td>{{data.registeredCapitalStr}}万元</td>
				</tr>
            </template>
			
        </table>
    </div>
</template>

<script>
export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
        userType:{
            type:[Number,String],
            default:''
        },
        userName:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            dataLoading:false,
            data:null,
            action:{
                2:{ // 艺人
                    financeInfo:'/performer/financeInfo',
                },
                3:{ // 场地
                    financeInfo:'/site/financeInfo',
                },
                5:{ // 厂牌
                    financeInfo:'/brand/financeInfo',
                }
            },
        };
    },
    computed:{
        accountType(){
            return new Map([
                [1,'企业'],
                [2,'个人或者其他']
            ])
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        //获取认证信息
        getData(){
            this.dataLoading = true;
            this.$request({
                url: this.action[this.userType].financeInfo,
                method: "POST",
                data: {id: this.userId},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1) {
                        this.data = result.receivablesInfoVO;
                        this.$emit('update:userName',result.idNameVO.name);

                        this.data.accountPic = this.data.accountPic ? this.data.accountPic.split(',') : [];
                        this.data.otherPic = this.data.otherPic ? this.data.otherPic.split(',') : [];
                        // this.data.licensePic = this.data.licensePic ? this.data.licensePic.split(',') : [];
                        // this.data.corporationIdPic = this.data.corporationIdPic ? this.data.corporationIdPic.split(',') : [];

                    } else {
                        return this.$message.error(msg || "获取财务信息失败");
                    }
                }).catch(() => {
                    return this.$message.error("获取财务信息失败");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
    }
}
</script>


<style lang="scss" scoped>
.info-table{
    th{
        width: 140px;
    }
    td{
        .el-image{
            width: 200px;
            height: 120px;
            margin: 5px;
        }
    }
}
</style>